document.documentElement.classList.remove('no-js');

class CleangorHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-menu-toggle]');
    this.drawer = document.querySelector('[data-mobile-menu]');
    this.overlay = document.querySelector('[data-menu-overlay]');
    this.closeButton = document.querySelector('[data-menu-close]');
    this.cartToggle = this.querySelector('[data-cart-toggle]');
    this.cartDrawer = this.querySelector('[data-cart-drawer]');
    this.cartOverlay = this.querySelector('[data-cart-overlay]');
    this.cartClose = this.querySelector('[data-cart-close]');
    if (!this.toggle || !this.drawer) return;
    this.toggle.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    this.cartToggle?.addEventListener('click', () => this.openCart());
    this.cartClose?.addEventListener('click', () => this.closeCart());
    this.cartOverlay?.addEventListener('click', () => this.closeCart());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { this.close(); this.closeCart(); }
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    document.body.classList.add('menu-open');
    this.toggle.setAttribute('aria-expanded', 'true');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.closeButton?.focus();
  }

  close() {
    this.drawer.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.drawer.setAttribute('aria-hidden', 'true');
  }

  openCart() {
    this.close();
    this.cartDrawer?.classList.add('is-open');
    this.cartOverlay?.classList.add('is-open');
    document.body.classList.add('menu-open');
    this.cartToggle?.setAttribute('aria-expanded', 'true');
    this.cartDrawer?.setAttribute('aria-hidden', 'false');
    this.cartClose?.focus();
  }

  closeCart() {
    this.cartDrawer?.classList.remove('is-open');
    this.cartOverlay?.classList.remove('is-open');
    if (!this.drawer?.classList.contains('is-open')) document.body.classList.remove('menu-open');
    this.cartToggle?.setAttribute('aria-expanded', 'false');
    this.cartDrawer?.setAttribute('aria-hidden', 'true');
  }
}

if (!customElements.get('cleangor-header')) {
  customElements.define('cleangor-header', CleangorHeader);
}
